import {
  Box,
  Button,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";
import { Add, Delete, Close } from "@mui/icons-material";
import provinces from "../../provinces.json";
import { Toaster } from "react-hot-toast";
import img from "../../images/profile_example.jpg";

const PersonalInfoForm = ({
  readCard,
  formData,
  handleChange,
  customerGroups,
  group,
  setGroup,
  personType,
  setPersonType,
  cars,
  drivers,
  handleAddCar,
  handleAddDriver,
  handleDeleteCar,
  handleDeleteDriver,
  handleCarChange,
  handleDriverChange,
  handleSubmit,
}) => {
  return (
    <Box sx={{ p: 4 }}>
      <Toaster position="bottom-right" reverseOrder={false} />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" gutterBottom>
          ข้อมูลซัพพลายเออร์
        </Typography>
        <Button onClick={readCard}>ดึงข้อมูลบัตรประชาชน</Button>
      </Box>

      <Grid container>
        <Grid item xs={12} sm={3}>
          <img
            src={formData.img == null ? img : formData.img}
            alt="รูปโปรไฟล์"
            style={{
              width: 200,
              height: 200,
              display: "block",
              margin: "0 auto",
              // borderRadius: "50%",
              objectFit: "fit", // ป้องกันภาพบิด
            }}
          />
        </Grid>

        <Grid item xs={12} sm={9}>
          <FormLabel>ประเภทบุคคล</FormLabel>
          <RadioGroup
            row
            value={personType}
            onChange={(e) => setPersonType(e.target.value)}
          >
            <FormControlLabel
              value="normal"
              control={<Radio />}
              label="บุคคลธรรมดา"
            />
            <FormControlLabel
              value="corporate"
              control={<Radio />}
              label="นิติบุคคล"
            />
          </RadioGroup>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="ชื่อ-นามสกุล"
                required
                margin="normal"
                value={formData.name}
                onChange={handleChange("name")}
              />
            </Grid>
            {personType !== "corporate" && (
              <Grid item xs={12} sm={6}>
                <TextField
                  type="date"
                  fullWidth
                  label="วันเดือนปีเกิด"
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  value={formData.dob}
                  onChange={handleChange("dob")}
                />
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={
                  personType !== "corporate"
                    ? "เลขบัตรประชาชน"
                    : "เลขประจำตัวผู้เสียภาษี"
                }
                margin="normal"
                value={formData.citizenId}
                onChange={handleChange("citizenId")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="เบอร์โทรศัพท์"
                margin="normal"
                value={formData.phone}
                onChange={handleChange("phone")}
              />
            </Grid>
          </Grid>

          <FormControl fullWidth margin="normal">
            <InputLabel>กลุ่ม</InputLabel>
            <Select
              value={group}
              label="กลุ่ม"
              onChange={(e) => setGroup(e.target.value)}
              endAdornment={
                group && (
                  <IconButton
                    size="small"
                    edge="end"
                    onClick={() => setGroup("")}
                    sx={{ mr: 1 }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                )
              }
            >
              {customerGroups.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sx={{ my: 1 }}>
          <TextField
            fullWidth
            label="ที่อยู่"
            margin="normal"
            value={formData.address}
            onChange={handleChange("address")}
          />
        </Grid>

        {cars.map((car, index) => (
          <Grid container spacing={2} key={index} alignItems="center" mb={2}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel>ประเภทรถ</InputLabel>
                <Select
                  value={car.type}
                  label="ประเภทรถ"
                  onChange={(e) =>
                    handleCarChange(index, "type", e.target.value)
                  }
                >
                  <MenuItem value="รถกระบะ">รถกระบะ</MenuItem>
                  <MenuItem value="รถเก๋ง">รถเก๋ง</MenuItem>
                  <MenuItem value="รถพวงข้าง">รถพวงข้าง</MenuItem>
                  <MenuItem value="รถ6ล้อ">รถ6ล้อ</MenuItem>
                  <MenuItem value="รถ10ล้อ">รถ10ล้อ</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="ทะเบียนรถ"
                value={car.license}
                onChange={(e) =>
                  handleCarChange(index, "license", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel>จังหวัด</InputLabel>
                <Select
                  value={car.province}
                  label="จังหวัด"
                  onChange={(e) =>
                    handleCarChange(index, "province", e.target.value)
                  }
                >
                  {provinces.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={1}>
              <IconButton color="error" onClick={() => handleDeleteCar(index)}>
                <Delete />
              </IconButton>
            </Grid>
          </Grid>
        ))}

        <Grid item xs={12} sx={{ mb: 5 }}>
          <Button startIcon={<Add />} onClick={handleAddCar}>
            เพิ่มรถยนต์
          </Button>
        </Grid>

        {drivers.map((driver, index) => (
          <Grid
            container
            spacing={2}
            key={index}
            alignItems="center"
            sx={{ mb: 2 }}
          >
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="ชื่อ"
                value={driver.name}
                onChange={(e) =>
                  handleDriverChange(index, "name", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                label="นามสกุล"
                value={driver.surname}
                onChange={(e) =>
                  handleDriverChange(index, "surname", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="เลขบัตรประชาชน"
                value={driver.idCard}
                onChange={(e) =>
                  handleDriverChange(index, "idCard", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton
                color="error"
                onClick={() => handleDeleteDriver(index)}
              >
                <Delete />
              </IconButton>
            </Grid>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Button startIcon={<Add />} onClick={handleAddDriver}>
            เพิ่มคนขับรถ
          </Button>
        </Grid>

        {/* <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
          >
            ยืนยัน
          </Button>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default PersonalInfoForm;
